<template>
  <form>
    <div class="row">
      <div class="col-lg-12">
        <h3 class="card-title">{{$t('medium_grant.diligence__1_capacity_questionaire')}}</h3>
        <p>{{$t('medium_grant.diligence__2_capacity_questionaire_sub2')}}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="mt-4"></div>
        <h4 class="card-title">{{$t('medium_grant.diligence__3_governance')}}</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <label><strong>{{$t('medium_grant.diligence__3_governing_body')}}</strong></label>
        <div>
          <small>{{$t('medium_grant.diligence__3_governing_body_please_indicate')}}</small>
        </div>
        <div class="mt-3"></div>
        <base-checkbox name="checkbox" v-model="GrantForm.revisionModel.diligence.govBoardOfDirectors">
          {{$t('medium_grant.diligence__3_board_of_directors')}}
        </base-checkbox>
        <base-checkbox name="checkbox" v-model="GrantForm.revisionModel.diligence.govExecutive">
          {{$t('medium_grant.diligence__3_executive')}}
        </base-checkbox>
        <base-checkbox name="checkbox" v-model="GrantForm.revisionModel.diligence.noGovBody">
          {{$t('medium_grant.diligence__3_no_gov_body')}}
        </base-checkbox>
        <base-checkbox name="checkbox" v-model="GrantForm.revisionModel.diligence.govOther">
          {{$t('medium_grant.diligence__3_gov_other')}}
        </base-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="mt-4">
          <label>{{$t('medium_grant.diligence__3_gov_ifother')}}</label>
        </div>
        <textarea
          class="form-control"
          :placeholder="$t('medium_grant.diligence__3_gov_ifother')"
          v-model="GrantForm.revisionModel.diligence.textOtherGovernance"
        >
        </textarea>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="mt-5"></div>
        <label><strong>{{$t('medium_grant.diligence__3_is_governing_body_responsible')}}</strong></label>
        <div class="mt-3"></div>
        <div>
          <div class="form-check form-check-radio">
            <radio name="diligence.isGovBodyResponsible"
                   value="true"
                   v-model="GrantForm.revisionModel.diligence.isGovBodyResponsible"
            >
              {{$t('medium_grant.general__yes')}}
            </radio>
            <radio name="diligence.isGovBodyResponsible" value="false" v-model="GrantForm.revisionModel.diligence.isGovBodyResponsible">
              {{$t('medium_grant.general__no')}}
            </radio>
          </div>
        </div>
      </div>
    </div>

  </form>
</template>
<script>
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    }
  }
</script>